// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".search{display:flex;flex-direction:column;height:100%;width:100%;box-sizing:border-box}.search .searchResults{margin-bottom:44px}.search .origami-inputContainer{padding:0 24px;box-sizing:border-box}.search .origami-InputOutline{margin:0}.search .searchResultsContainer{overflow:auto;padding:0 24px}.search .origami-ButtonGroup{padding:0 24px}", ""]);
// Exports
module.exports = exports;
